'use strict';

import { appendParamToURL, removeParamFromURL } from 'Util/urlUtils';

class VZPorting extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['visible'];
    }

    connectedCallback() {
        this.notifyProductCard = this.notifyProductCard.bind(this);
        this.quantityField = this.querySelector('.js-quantity-field');
        this.quantityField.addEventListener('fieldUpdated', this.notifyProductCard);

        // Execute immediately, since this element will be replaced (and have it's value be reset)
        // when the vz-quantity-selector element is updated.
        this.notifyProductCard();
    }

    notifyProductCard() {
        const value = this.quantityField.value;
        const quantity = this.closest('form').querySelector('.js-quantity-selector').value;
        const valueToSend = Number(value) > Number(quantity) ? quantity : value;

        const element = this.querySelector('[data-url]');
        let url = element.getAttribute('data-url');
        url = removeParamFromURL(url, 'porting');
        url = appendParamToURL(url, 'porting', valueToSend);
        element.setAttribute('data-url', url);

        document.querySelector('vz-group-summary').dispatchEvent(
            new CustomEvent('portingChange', {
                detail: {
                    value: valueToSend
                }
            })
        );
    }
}

export default window.customElements.get('vz-porting') || VZPorting;
if (!window.customElements.get('vz-porting')) {
    window.customElements.define('vz-porting', VZPorting);
}
